import { AgentItemsListState, AgentSearchStatus, AgentListItem } from "app/pages/AgentSearch/modules/AgentItemsList/state";
import { Action, ActionType } from "app/pages/AgentSearch/actionTypes";
import { combineReducers } from "redux";
import { AgentSearchResult } from "app/shared/model/Agent";

function agents(state: AgentListItem[]|undefined, action: Action) : AgentListItem[] {
    if (!state) {
        return [];
    } 

    switch(action.type) {
        case ActionType.PageLoaded: 
            return action.agents.length > 0
                ? action.agents.map(x => {
                    return mapToAgentListItem(x)
                    }) 
                : []
        case ActionType.AgentSearchResult: 
            const agents = action.agents.map(x => {
                return mapToAgentListItem(x)
            }); 
            return agents; 

        case ActionType.ChangeSearchStatus: 
            return (action.status === AgentSearchStatus.Errored)
                ? []
                : state; 

        default: 
            return state; 
    }
}

function searchTerm(state: string|undefined, action: Action) : string {
    if (state === undefined) {
        return '';
    } 

    switch(action.type) {
        case ActionType.PageLoaded: 
            return (action.searchTerm !== '')
                ? action.searchTerm
                : state;  
        case ActionType.ChangeSearchTerm: 
            if (action.searchTerm === state)
                return state;  

            sessionStorage.setItem('AgentSearchTerm', action.searchTerm)
            return action.searchTerm; 
        default: 
            return state; 
    }
}

function searchStatus(state: AgentSearchStatus|undefined, action: Action) : AgentSearchStatus {
    if (!state) {
        return AgentSearchStatus.Success;
    } 

    switch(action.type) {
        case ActionType.ChangeSearchStatus: 
            return action.status; 
        case ActionType.AgentSearchResult:
            return AgentSearchStatus.Success;
        default: 
            return state; 
    }
}

function mapToAgentListItem(agent: AgentSearchResult) : AgentListItem {
    return {
        id: agent.id, 
        name: agent.name, 
        ownerFullName: agent.ownerFullName, 
        countryName: agent.countryName, 
        countryIsoCode: agent.countryIsoCode, 
        classification: agent.classification, 
        status: {
            name: agent.status, 
            cssClass: getStatusCssClass(agent.status)
        }
    }
}

function getStatusCssClass(status: string) {
    if (status.toLowerCase() === 'live')
        return 'green'; 
    if (status.toLowerCase() === 'stopped')
        return 'red'; 
    if (status.toLowerCase() === 'lead')
        return 'olive'; 
    return 'grey'; 
}

export const reducer = combineReducers({
    agents,
    searchTerm, 
    searchStatus
});